module.exports = __webpack_public_path__ + "static/PanelandToolbar-29fd50b75c269a24838d4fb42b8b8f8e.png";